import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

const PaymentQrCode = ({ value, size = 88, title, className = '' }) => {
  if (!value) return null;
  return (
    <div className={`inline-flex flex-col items-center gap-1 ${className}`} title={title}>
      <QRCodeSVG value={value} size={size} level="M" includeMargin />
    </div>
  );
};

export default PaymentQrCode;
